export function assertObjectIsEmpty(obj: Record<string, never>): void {
  if (Object.getOwnPropertyNames(obj).length > 0) {
    throw new Error(`Value is not empty: ${JSON.stringify(obj)}`);
  }
}
